var map = {
	"./0.png": "J7D/",
	"./P1.png": "CiJp",
	"./P2.png": "DOU1",
	"./P3.png": "oBJg",
	"./P4.png": "fmDl",
	"./P5.png": "+52c",
	"./P6.png": "XwAc",
	"./P7.png": "R9bp",
	"./P8.png": "FNYy",
	"./P9.png": "gGhZ",
	"./S.png": "ViYW",
	"./W.png": "cXgp",
	"./wbg.png": "3VSj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AOTq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hunter ^\.\/.*\.png$
// module id = AOTq
// module chunks = 0